<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<form
  (ngSubmit)="searchUser()"
  #searchForm="ngForm"
  class="flex items-center w-2/4 pb-4"
>
  <nz-input-group nzSearch nzSize="large" [nzAddOnAfter]="suffixButton">
    <input
      type="text"
      name="email"
      [(ngModel)]="email"
      nz-input
      placeholder="Search user by email, ID, or phone number"
      required
    />
  </nz-input-group>

  <ng-template #suffixButton>
    <button nz-button nzType="primary" nzSize="large" nzSearch type="submit">
      Search
    </button>
  </ng-template>
</form>

<nz-spin [nzSpinning]="spinner" nzTip="Fetching User Profile......">
  <div *ngIf="spinner" class="h-screen w-full"></div>
  <div *ngIf="!spinner && searched" style="background: #ececec; padding: 30px">
    <div class="flex flex-row space-x-4 pb-4">
      <div>
        <button
          nz-button
          nzType="primary"
          nzSize="large"
          (click)="callToUser()"
        >
          Call to user
        </button>
      </div>
      <div>
        <button
          nz-button
          nzType="primary"
          nzSize="large"
          (click)="openWhatsapp()"
        >
          WhatsApp
        </button>
      </div>
      <div>
        <button
          nz-button
          nzType="primary"
          nzSize="large"
          (click)="blockOrUnClockModalOpen()"
        >
          {{
            userProfileResp.userCardDetails.userTags.includes(
              userTags.SESSION_BOOKING_BLOCKED
            )
              ? "Un-BLock"
              : "Block"
          }}
          Session booking
        </button>
      </div>
      <div>
        <button
          nz-button
          nzType="primary"
          nzSize="large"
          (click)="openDrawer()"
        >
          Update Profile
        </button>
      </div>
      <div>
        <button
          nz-button
          nzType="primary"
          nzSize="large"
          (click)="openEmailModal()"
        >
          Update Email
        </button>
      </div>
      <div>
        <button
          nz-button
          nzType="default"
          nzSize="large"
          (click)="openEmailAuditLogModal()"
        >
          Email Change History
        </button>
      </div>
      <div>
        <button
          nz-button
          nzType="primary"
          nzSize="large"
          (click)="fixMemberPassModalOpen()"
          *ngIf="shouldShowFixMemberPassButton()"
        >
          Fix Member Pass
        </button>
      </div>
      <div>
        <button
          nz-button
          nzType="primary"
          nzSize="large"
          [nzLoading]="retryingLabReports"
          (click)="retryUserLabReports()"
        >
          Retry Lab Reports
        </button>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="6">
        <nz-card nzTitle="User id">
          <p>{{ userProfileResp.userCardDetails.id }}</p>
        </nz-card>
      </div>
      <div nz-col [nzSpan]="6">
        <nz-card nzTitle="User Name">
          <p>{{ userProfileResp.userCardDetails.name }}</p>
        </nz-card>
      </div>
      <div nz-col [nzSpan]="6">
        <nz-card nzTitle="User Email">
          <p>{{ userProfileResp.userCardDetails.email }}</p>
        </nz-card>
      </div>
      <!-- <div nz-col [nzSpan]="6">
        <nz-card nzTitle="User Phone">
          <p>{{ userProfileResp.userCardDetails.phoneNumber }}</p>
        </nz-card>
      </div> -->
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="6">
        <nz-card nzTitle="User Partner Name">
          <p>{{ userProfileResp.userCardDetails.userPartner }}</p>
        </nz-card>
      </div>
      <div nz-col [nzSpan]="6">
        <nz-card nzTitle="User Joined Time">
          <p>
            {{
              utils.convertEpochToFormattedDate(
                userProfileResp.userCardDetails.joinedTime?.toString()!
              )
            }}
          </p>
        </nz-card>
      </div>
      <div nz-col [nzSpan]="6">
        <nz-card nzTitle="User Time Zone">
          <p>{{ userProfileResp.userCardDetails.userTimeZone }}</p>
        </nz-card>
      </div>
    </div>
    <div nz-row [nzGutter]="8" class="pt-2">
      <div nz-col [nzSpan]="6">
        <nz-card nzTitle="Daily Streak">
          <p>{{ userProfileResp.userCardDetails.dailyStreak }}</p>
        </nz-card>
      </div>
      <div nz-col [nzSpan]="6">
        <nz-card nzTitle="Gender">
          <p>{{ userProfileResp.userCardDetails.gender }}</p>
        </nz-card>
      </div>
      <div nz-col [nzSpan]="6">
        <nz-card nzTitle="Age">
          <p>{{ userProfileResp.userCardDetails.age }}</p>
        </nz-card>
      </div>
      <div nz-col [nzSpan]="6">
        <nz-card nzTitle="LastSeen">
          <p>
            {{
              utils.convertEpochToFormattedDate(
                userProfileResp.userCardDetails.lastSeen
              )
            }}
          </p>
        </nz-card>
      </div>
    </div>
    <div nz-row [nzGutter]="8" class="pt-2">
      <div nz-col [nzSpan]="6">
        <nz-card nzTitle="Circles Joined">
          <div
            class="mt-2"
            *ngFor="
              let data of userProfileResp.userCardDetails.circlesJoinedWithColor
            "
          >
            <nz-tag [nzColor]="data.color">{{ data.data }}</nz-tag>
          </div>
        </nz-card>
      </div>
      <div nz-col [nzSpan]="6">
        <nz-card nzTitle="User Interests">
          <div
            class="mt-2"
            *ngFor="
              let data of userProfileResp.userCardDetails.userInterestsWithColor
            "
          >
            <nz-tag [nzColor]="data.color">{{ data.data }}</nz-tag>
          </div>
        </nz-card>
      </div>
      <div nz-col [nzSpan]="6">
        <nz-card nzTitle="User Life Style Choices">
          <div
            class="mt-2"
            *ngFor="
              let data of userProfileResp.userCardDetails
                .userLifestyleChoicesWithColor
            "
          >
            <nz-tag [nzColor]="data.color">{{ data.data }}</nz-tag>
          </div>
        </nz-card>
      </div>
      <div nz-col [nzSpan]="6">
        <nz-card nzTitle="Average Time used">
          <p>{{ userProfileResp.userCardDetails.avgUseTime }}</p>
        </nz-card>
      </div>
    </div>
  </div>
</nz-spin>
<div *ngIf="!spinner && searched" style="background: #ececec; padding: 30px">
  <div nz-row [nzGutter]="8">
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="Total Sessions">
        <p>{{ therapyCards.totalSessions }}</p>
      </nz-card>
    </div>
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="Completed Sessions">
        <p>{{ therapyCards.completedSessions }}</p>
      </nz-card>
    </div>
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="Confirmed Sessions">
        <p>
          {{ therapyCards.confirmedSessions }}
        </p>
      </nz-card>
    </div>
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="Cancelled Sessions">
        <p>{{ therapyCards.cancelledSessions }}</p>
      </nz-card>
    </div>
  </div>
  <div nz-row [nzGutter]="8" class="pt-2">
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="No Show Therapist">
        <p>{{ therapyCards.noShowTherapistSessions }}</p>
      </nz-card>
    </div>
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="No Show User">
        <p>{{ therapyCards.noShowUserSessions }}</p>
      </nz-card>
    </div>
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="Feedback Pending">
        <p>
          {{ therapyCards.feedbackPendingSessions }}
        </p>
      </nz-card>
    </div>
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="Tech Issue">
        <p>{{ therapyCards.techIssueSessions }}</p>
      </nz-card>
    </div>
  </div>
  <div nz-row [nzGutter]="8" class="pt-2">
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="Total Chat Sessions">
        <p>{{ userProfileResp.userTableDetails.chatSessions.length }}</p>
      </nz-card>
    </div>
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="Total New ChatRequest">
        <p>{{ userProfileResp.userTableDetails.newChatRequest.length }}</p>
      </nz-card>
    </div>
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="Total Live Joined">
        <p>
          {{ userProfileResp.userTableDetails.liveJoins.length }}
        </p>
      </nz-card>
    </div>
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="Parables Watched">
        <p>
          {{ userProfileResp.userTableDetails.parablesWatchHistory.length }}
        </p>
      </nz-card>
    </div>
  </div>
  <div nz-row [nzGutter]="8" class="pt-2">
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="Live Watched">
        <p>{{ userProfileResp.userTableDetails.liveHistoryWatch.length }}</p>
      </nz-card>
    </div>
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="Circle Post Impressions">
        <p>
          {{ userProfileResp.userTableDetails.circlePostImpression.length }}
        </p>
      </nz-card>
    </div>
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="Circle Post Reactions">
        <p>
          {{ userProfileResp.userTableDetails.circlePostReactions.length }}
        </p>
      </nz-card>
    </div>
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="Routine Logs">
        <p>{{ userProfileResp.userTableDetails.routinesLog.length }}</p>
      </nz-card>
    </div>
  </div>
  <div nz-row [nzGutter]="8" class="pt-2">
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="Poll Logs">
        <p>{{ userProfileResp.userTableDetails.pollsLog.length }}</p>
      </nz-card>
    </div>
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="Questionnare Logs">
        <p>{{ userProfileResp.userTableDetails.QuestionnareLog.length }}</p>
      </nz-card>
    </div>
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="Total Posts">
        <p>
          {{ userProfileResp.userTableDetails.circlePosts.length }}
        </p>
      </nz-card>
    </div>
    <div nz-col [nzSpan]="6">
      <nz-card nzTitle="Total Comments">
        <p>{{ userProfileResp.userTableDetails.circlePostComments.length }}</p>
      </nz-card>
    </div>
    <div
      nz-col
      [nzSpan]="6"
      class="pt-2"
      *ngIf="userProfileResp.userTableDetails.lyfisScore !== null"
    >
      <nz-card
        nzTitle="Total Lyfis Snapshots"
        *ngIf="
          userProfileResp.userTableDetails.lyfisScore.lyfisSnapshotCount > -1
        "
      >
        <p>
          {{ userProfileResp.userTableDetails.lyfisScore.lyfisSnapshotCount }}
        </p>
      </nz-card>
    </div>
  </div>
</div>
<div *ngIf="!spinner && searched" style="padding: 0 30px 20px">
  <app-goals-panel
    [userId]="userProfileResp.userCardDetails.id"
  ></app-goals-panel>
</div>
<div *ngIf="!spinner && searched">
  <nz-collapse nzAccordion>
    <nz-collapse-panel
      *ngFor="let panel of paginatedData; trackBy: trackByName"
      [nzHeader]="panel.name"
      [nzActive]="panel.active"
      (nzActiveChange)="activeChange($event)"
    >
      <div class="overflow-x-auto">
        <nz-table
          [nzData]="panel.data"
          [nzPageSize]="10"
          [nzShowPagination]="false"
        >
          <thead>
            <tr>
              <th *ngFor="let key of getKeys(panel.data[0])">
                {{ key }}
              </th>
              <th *ngIf="panel.name === 'sessions'">Policy Trace</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of panel.data">
              <td *ngFor="let key of getKeys(row)">
                <ng-container
                  *ngIf="isArrayOfObjects(row[key]); else regularCell"
                >
                  <button
                    nz-button
                    class="bg-bunting text-white"
                    (click)="open(getKeys(row[key][0]), row[key], key)"
                  >
                    {{ "Click " + key }}
                  </button>
                </ng-container>

                <ng-template #regularCell>
                  <ng-container [ngSwitch]="key">
                    <button
                      *ngSwitchCase="'action'"
                      nz-button
                      nzType="primary"
                      nzSize="small"
                      (click)="handleAction(panel.name)"
                    >
                      <i nz-icon nzType="eye"></i> View
                    </button>

                    <span *ngSwitchDefault>
                      {{ row[key] }}
                    </span>
                  </ng-container>
                </ng-template>
              </td>
              <!-- Policy trace button — only in sessions panel -->
              <td *ngIf="panel.name === 'sessions'">
                <button
                  *ngIf="row.policyTrace"
                  nz-button
                  nzType="default"
                  nzSize="small"
                  (click)="openPolicyTrace(row)"
                >
                  <i nz-icon nzType="audit"></i> Policy Trace
                </button>
                <span *ngIf="!row.policyTrace" class="text-gray-400 text-xs"
                  >—</span
                >
              </td>
            </tr>
          </tbody>
        </nz-table>
        <div class="p-4">
          <nz-pagination
            [nzPageIndex]="currentPage"
            [nzTotal]="panel.totalCount"
            (nzPageIndexChange)="changePage($event)"
          ></nz-pagination>
        </div>
      </div>
    </nz-collapse-panel>
  </nz-collapse>

  <!-- ── Policy Debug section ── -->
  <nz-card nzTitle="Policy Debug" style="margin-top: 16px">
    <ng-template #debugExtra>
      <nz-tag nzColor="purple">Ops only</nz-tag>
    </ng-template>
    <div class="flex flex-wrap items-end gap-4 mb-4">
      <div class="flex flex-col gap-1">
        <label class="text-xs text-gray-500 font-semibold">Vertical</label>
        <nz-select
          [(ngModel)]="debugVerticalId"
          nzPlaceHolder="Select Vertical"
          style="width: 200px"
          (ngModelChange)="onDebugVerticalChange()"
        >
          <nz-option
            *ngFor="let v of verticals"
            [nzValue]="v.m_id"
            [nzLabel]="v.data"
          ></nz-option>
        </nz-select>
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-xs text-gray-500 font-semibold">Concern</label>
        <nz-select
          [(ngModel)]="debugConcernId"
          nzPlaceHolder="Select Concern"
          style="width: 220px"
          [nzDisabled]="!debugVerticalId"
        >
          <nz-option
            *ngFor="let c of filteredConcerns"
            [nzValue]="c.m_id"
            [nzLabel]="c.data"
          ></nz-option>
        </nz-select>
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-xs text-gray-500 font-semibold"
          >Therapist <span class="text-gray-400">(optional)</span></label
        >
        <nz-select
          [(ngModel)]="debugTherapistId"
          nzPlaceHolder="Search therapist..."
          style="width: 260px"
          nzShowSearch
          nzAllowClear
          [nzFilterOption]="therapistFilterFn"
        >
          <nz-option
            *ngFor="let t of therapists"
            [nzValue]="t._id"
            [nzLabel]="therapistDisplayName(t)"
          ></nz-option>
        </nz-select>
      </div>
      <button
        nz-button
        nzType="primary"
        [nzLoading]="debugLoading"
        (click)="evaluateUserPolicy()"
      >
        Evaluate Policy
      </button>
    </div>

    <div *ngIf="debugResult" class="flex flex-col gap-4">
      <!-- ── Final Decision (top, prominent) ── -->
      <div
        class="rounded-lg border-2 p-4"
        [ngClass]="
          debugResult.finalOutputs.sessionAllowed === false
            ? 'border-red-300 bg-red-50'
            : 'border-green-300 bg-green-50'
        "
      >
        <div class="flex items-center gap-3 mb-3">
          <span class="text-xl">{{
            debugResult.finalOutputs.sessionAllowed === false ? "🚫" : "✅"
          }}</span>
          <span
            class="text-base font-bold"
            [ngClass]="
              debugResult.finalOutputs.sessionAllowed === false
                ? 'text-red-700'
                : 'text-green-700'
            "
          >
            {{
              debugResult.finalOutputs.sessionAllowed === false
                ? "Session Blocked"
                : "Session Allowed"
            }}
          </span>
          <span class="text-sm text-gray-500 ml-auto"
            >{{ debugMatchedCount() }} / {{ debugResult.rules.length }} rules
            matched</span
          >
        </div>
        <div class="flex flex-wrap gap-3">
          <ng-container
            *ngFor="let entry of objectEntries(debugResult.finalOutputs)"
          >
            <div
              class="flex flex-col rounded bg-white border px-3 py-2 min-w-[120px]"
            >
              <span
                class="text-xs text-gray-400 font-medium uppercase tracking-wide"
                >{{ entry[0] }}</span
              >
              <span class="text-sm font-bold text-gray-800 mt-0.5">{{
                entry[1]
              }}</span>
              <span
                *ngIf="debugResult.winnersByField[entry[0]]"
                class="text-xs text-amber-600 mt-1 truncate"
                [title]="debugResult.winnersByField[entry[0]]?.ruleName"
                >↑ {{ debugResult.winnersByField[entry[0]]?.ruleName }}</span
              >
            </div>
          </ng-container>
        </div>
      </div>

      <!-- ── Rules + Facts side by side ── -->
      <div class="flex gap-4" style="align-items: flex-start">
        <!-- Rules Evaluated (wider) -->
        <div class="flex-1 min-w-0">
          <div
            class="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2"
          >
            Rules Evaluated
          </div>
          <div class="flex flex-col gap-1">
            <div
              *ngFor="let rule of debugResult.rules"
              class="flex items-center gap-2 px-3 py-2 rounded border text-sm cursor-pointer transition-all hover:shadow-sm"
              [ngClass]="
                rule.matched
                  ? 'bg-green-50 border-green-200 hover:bg-green-100'
                  : 'bg-gray-50 border-gray-200 opacity-70 hover:opacity-100 hover:bg-gray-100'
              "
              (click)="openRuleDetail(rule)"
            >
              <span
                class="text-xs font-bold px-1.5 py-0.5 rounded flex-shrink-0"
                style="
                  background: #f0f0f0;
                  color: #555;
                  min-width: 28px;
                  text-align: center;
                "
                >P{{ rule.priority }}</span
              >
              <span
                class="text-xs flex-shrink-0"
                [title]="rule.isGlobal ? 'Global rule' : 'Partner rule'"
                >{{ rule.isGlobal ? "🌐" : "🏢" }}</span
              >
              <span
                class="flex-1 min-w-0 truncate font-medium"
                [title]="rule.ruleName"
                >{{ rule.ruleName }}</span
              >
              <span
                class="text-xs flex-shrink-0 font-semibold px-2 py-0.5 rounded-full"
                [ngClass]="
                  rule.matched
                    ? 'bg-green-100 text-green-700'
                    : 'bg-gray-200 text-gray-500'
                "
                >{{ rule.matched ? "✓ matched" : "no match" }}</span
              >
            </div>
          </div>
        </div>

        <!-- Computed Facts (right side, scrollable) -->
        <div style="width: 380px; flex-shrink: 0">
          <div
            class="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2"
          >
            Computed Facts
          </div>
          <div
            class="rounded border border-gray-200 overflow-y-auto"
            style="max-height: 420px"
          >
            <table class="w-full text-xs">
              <tbody>
                <tr
                  *ngFor="
                    let entry of objectEntries(debugResult.facts);
                    let odd = odd
                  "
                  [ngClass]="odd ? 'bg-gray-50' : 'bg-white'"
                >
                  <td
                    class="px-3 py-1.5 text-gray-500 font-medium w-1/2 align-top"
                    style="word-break: break-all"
                  >
                    {{ entry[0] }}
                  </td>
                  <td
                    class="px-3 py-1.5 font-mono text-gray-800 w-1/2 align-top"
                    style="word-break: break-all"
                  >
                    <span [title]="entry[1] | json">{{ entry[1] | json }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </nz-card>

  <!-- ── Personal Policy Rules (APH-5224) ── -->
  <nz-card nzTitle="Personal Policy Rules" style="margin-top: 16px">
    <ng-template #personalRulesExtra>
      <nz-tag nzColor="magenta">{{ personalRulesUI.length }} rule{{ personalRulesUI.length === 1 ? '' : 's' }}</nz-tag>
    </ng-template>
    <div class="text-xs text-gray-500 mb-3">
      Per-employee overrides for this one user — always win over company/global rules for whatever
      output field they set, regardless of priority number. Only affects this user.
    </div>

    <nz-spin [nzSpinning]="personalRulesLoading">
      <div
        *ngIf="!personalRulesLoading && personalRulesUI.length === 0"
        class="text-center py-6 text-sm border border-dashed border-gray-200 rounded-lg text-gray-400 mb-2"
      >
        No personal rules for this user yet.
      </div>

      <div
        *ngFor="let rule of personalRulesUI"
        class="border rounded-lg mb-1.5 overflow-hidden transition-colors"
        [style.border-color]="rule.expanded ? '#1890ff' : '#e8e8e8'"
      >
        <!-- Collapsed header -->
        <div
          class="flex items-center gap-2 px-4 py-2.5 cursor-pointer select-none min-h-[46px]"
          [ngClass]="rule.expanded ? 'bg-blue-50' : 'hover:bg-gray-50'"
          (click)="togglePersonalRuleExpand(rule)"
        >
          <span
            class="text-xs font-bold px-2 py-0.5 rounded-full flex-shrink-0"
            style="background:#f5f5f5;border:1px solid #e0e0e0;color:#666;min-width:32px;text-align:center"
          >P{{ rule.priority }}</span>
          <span
            class="text-xs font-medium px-2 py-0.5 rounded flex-shrink-0"
            style="background:#f5f5f5;color:#555"
          >{{ rule.action }}</span>
          <span class="text-xs font-medium text-gray-700 truncate" style="max-width:140px">
            {{ personalScopeSummary(rule) }}
          </span>
          <span class="text-gray-300 flex-shrink-0">·</span>
          <span
            class="text-xs px-2 py-0.5 rounded flex-shrink-0 truncate"
            style="background:#f9fafb;border:1px solid #e8ecf4;color:#6b7280;max-width:180px"
          >{{ personalCondSummary(rule) }}</span>
          <span class="text-gray-300 flex-shrink-0">→</span>
          <span
            class="text-xs px-2 py-0.5 rounded flex-shrink-0 truncate"
            style="background:#f0fdf4;border:1px solid #bbf7d0;color:#166534;max-width:200px"
          >{{ personalThenSummary(rule) }}</span>
          <div class="flex-1"></div>
          <nz-tag [nzColor]="rule.active ? 'green' : 'default'" style="margin:0;flex-shrink:0">
            {{ rule.active ? 'Active' : 'Off' }}
          </nz-tag>
          <button
            nz-button nzType="link" nzDanger nzSize="small"
            style="padding:0 4px;flex-shrink:0"
            (click)="$event.stopPropagation(); deletePersonalRule(rule)"
          >✕</button>
          <span class="text-gray-400 text-xs flex-shrink-0 ml-1">{{ rule.expanded ? '▲' : '▼' }}</span>
        </div>

        <!-- Expanded body -->
        <div *ngIf="rule.expanded" class="border-t border-gray-100">

          <!-- FOR zone -->
          <div class="p-4 border-b border-gray-100">
            <div class="text-xs font-bold uppercase tracking-wider mb-3" style="color:#9ca3af">
              FOR — what does this rule apply to?
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <label class="block mb-1 text-xs text-gray-500 font-medium">Action</label>
                <nz-select [(ngModel)]="rule.action" class="w-full" (ngModelChange)="onPersonalRuleActionChange(rule)">
                  <nz-option *ngFor="let a of PERSONAL_RULE_ACTIONS" [nzValue]="a" [nzLabel]="a"></nz-option>
                </nz-select>
              </div>
              <ng-container *ngIf="rule.action === 'Session Booking'">
                <div>
                  <label class="block mb-1 text-xs text-gray-500 font-medium">
                    Vertical <span class="text-gray-300 italic font-normal">optional</span>
                  </label>
                  <nz-select [(ngModel)]="rule.scope.verticalId" class="w-full" nzMode="multiple" nzAllowClear nzPlaceholder="Any vertical">
                    <nz-option *ngFor="let v of verticals" [nzValue]="v.m_id" [nzLabel]="v.data"></nz-option>
                  </nz-select>
                </div>
                <div>
                  <label class="block mb-1 text-xs text-gray-500 font-medium">
                    Concern <span class="text-gray-300 italic font-normal">optional</span>
                  </label>
                  <nz-select [(ngModel)]="rule.scope.concernId" class="w-full" nzMode="multiple" nzAllowClear nzPlaceholder="Any concern" nzShowSearch>
                    <nz-option *ngFor="let c of personalConcernsForRule(rule)" [nzValue]="c.m_id" [nzLabel]="c.data"></nz-option>
                  </nz-select>
                </div>
                <div>
                  <label class="block mb-1 text-xs text-gray-500 font-medium">
                    Expert level <span class="text-gray-300 italic font-normal">optional</span>
                  </label>
                  <nz-select [(ngModel)]="rule.scope.expertLevelId" class="w-full" nzAllowClear nzPlaceholder="Any level">
                    <nz-option *ngFor="let e of expertLevels" [nzValue]="e.m_id" [nzLabel]="e.data"></nz-option>
                  </nz-select>
                </div>
                <div>
                  <label class="block mb-1 text-xs text-gray-500 font-medium">
                    Experts <span class="text-gray-300 italic font-normal">optional — one or more named therapists</span>
                  </label>
                  <nz-select [(ngModel)]="rule.scope.therapistIds" class="w-full" nzMode="multiple" nzAllowClear nzShowSearch [nzFilterOption]="therapistFilterFn" nzPlaceholder="Any expert">
                    <nz-option *ngFor="let t of therapists" [nzValue]="t._id" [nzLabel]="therapistDisplayName(t)"></nz-option>
                  </nz-select>
                </div>
              </ng-container>
              <div>
                <label class="block mb-1 text-xs text-gray-500 font-medium">Priority</label>
                <nz-input-number [(ngModel)]="rule.priority" [nzMin]="0" class="w-full"></nz-input-number>
                <div class="text-xs text-gray-400 mt-1">Only breaks ties against other personal rules for this user — this tier already always wins over company/global.</div>
              </div>
              <div class="flex items-center justify-between gap-2 p-3 rounded" style="background:#f9fafb">
                <span class="text-sm font-medium">Active</span>
                <nz-switch [(ngModel)]="rule.active"></nz-switch>
              </div>
              <div class="md:col-span-2">
                <label class="block mb-1 text-xs text-gray-500 font-medium">Rule name</label>
                <input nz-input [(ngModel)]="rule.name" placeholder="e.g. Unlimited sessions with Raj" />
              </div>
            </div>
          </div>

          <!-- WHEN zone -->
          <div class="p-4 border-b border-gray-100">
            <div class="text-xs font-bold uppercase tracking-wider mb-3" style="color:#9ca3af">
              WHEN — condition
            </div>
            <div class="flex gap-2 mb-3">
              <button
                class="px-3 py-1 rounded text-xs cursor-pointer border transition-all"
                [style.border-color]="rule.conditionMode === 'always' ? '#1890ff' : '#d9d9d9'"
                [style.color]="rule.conditionMode === 'always' ? '#1890ff' : '#6b7280'"
                [style.background]="rule.conditionMode === 'always' ? '#e6f4ff' : '#fff'"
                (click)="rule.conditionMode = 'always'"
              >Always applies (no conditions)</button>
              <button
                class="px-3 py-1 rounded text-xs cursor-pointer border transition-all"
                [style.border-color]="rule.conditionMode === 'when' ? '#1890ff' : '#d9d9d9'"
                [style.color]="rule.conditionMode === 'when' ? '#1890ff' : '#6b7280'"
                [style.background]="rule.conditionMode === 'when' ? '#e6f4ff' : '#fff'"
                (click)="rule.conditionMode = 'when'"
              >Only when… (set conditions below)</button>
            </div>

            <ng-container *ngIf="rule.conditionMode === 'when'">
              <div *ngIf="rule.condRows.length > 1" class="flex items-center gap-2 mb-2">
                <span class="text-xs text-gray-500">Match</span>
                <nz-select [(ngModel)]="rule.condLogic" style="width:200px">
                  <nz-option nzValue="all" nzLabel="ALL conditions (AND)"></nz-option>
                  <nz-option nzValue="any" nzLabel="ANY condition (OR)"></nz-option>
                </nz-select>
              </div>

              <div *ngFor="let cond of rule.condRows; let i = index" class="flex items-center gap-2 mb-2 p-2 rounded" style="background:#fafafa;border:1px solid #f0f0f0">
                <nz-select [(ngModel)]="cond.fact" style="min-width:200px" [nzDropdownMatchSelectWidth]="false" (ngModelChange)="onPersonalFactChange(rule, cond)">
                  <nz-option *ngFor="let f of personalFactsFor(rule.action)" [nzValue]="f.value" [nzLabel]="f.label"></nz-option>
                </nz-select>
                <ng-container *ngIf="cond.fact === 'sessionsInLastNDays' || cond.fact === 'totalSessionsInLastNDays'">
                  <span class="text-xs text-gray-500 flex-shrink-0">in last</span>
                  <nz-input-number [(ngModel)]="cond.params!['days']" [nzMin]="1" style="width:72px" nzPlaceHolder="7"></nz-input-number>
                  <span class="text-xs text-gray-500 flex-shrink-0">days</span>
                </ng-container>
                <nz-select *ngIf="personalFactType(rule.action, cond.fact) === 'number'" [(ngModel)]="cond.operator" style="width:64px">
                  <nz-option *ngFor="let op of PERSONAL_RULE_NUM_OPS" [nzValue]="op.value" [nzLabel]="op.label"></nz-option>
                </nz-select>
                <nz-input-number *ngIf="personalFactType(rule.action, cond.fact) === 'number'" [(ngModel)]="cond.value" [nzMin]="0" style="width:100px"></nz-input-number>
                <nz-select *ngIf="personalFactType(rule.action, cond.fact) === 'bool'" [(ngModel)]="cond.value" style="width:120px">
                  <nz-option [nzValue]="true" nzLabel="Yes"></nz-option>
                  <nz-option [nzValue]="false" nzLabel="No"></nz-option>
                </nz-select>
                <button nz-button nzType="link" nzDanger nzSize="small" style="padding:0 4px;flex-shrink:0" (click)="removePersonalCond(rule, i)">✕</button>
              </div>

              <div *ngIf="rule.condRows.length === 0" class="text-xs text-gray-400 py-2">
                No conditions added — click "+ Add condition" below.
              </div>
              <button
                class="mt-1 px-3 py-1 rounded text-xs cursor-pointer border transition-all hover:border-blue-400 hover:text-blue-500 hover:bg-blue-50"
                style="border:1px dashed #d9d9d9;background:#fff;color:#9ca3af"
                (click)="addPersonalCond(rule)"
              >+ Add condition</button>
            </ng-container>
          </div>

          <!-- THEN zone -->
          <div class="p-4">
            <div class="text-xs font-bold uppercase tracking-wider mb-3" style="color:#9ca3af">
              THEN — outputs
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div *ngFor="let out of personalOutputsFor(rule.action)" [class.md:col-span-2]="out.type === 'text'" [hidden]="!isPersonalFieldVisible(rule, out)">
                <label class="block mb-1 text-xs font-medium" [class.text-gray-300]="isPersonalOutputDisabled(rule, out)" [class.text-gray-500]="!isPersonalOutputDisabled(rule, out)">{{ out.label }}</label>
                <nz-select
                  *ngIf="out.type === 'select'"
                  [(ngModel)]="rule.outputs[out.key]"
                  class="w-full"
                  nzPlaceHolder="— not set —"
                  [nzDisabled]="isPersonalOutputDisabled(rule, out)"
                  (ngModelChange)="out.key === 'sessionAllowed' || out.key === 'eventAllowed' || out.key === 'diagAllowed' ? onPersonalAllowedFieldChange(rule) : onPersonalSelfPayOutputChange(rule, out.key)"
                >
                  <nz-option nzValue="" nzLabel="— not set —"></nz-option>
                  <nz-option *ngFor="let opt of out.options" [nzValue]="opt.v" [nzLabel]="opt.l"></nz-option>
                </nz-select>
                <nz-input-number
                  *ngIf="out.type === 'number'"
                  [(ngModel)]="rule.outputs[out.key]"
                  class="w-full"
                  nzPlaceholder="not set"
                  [nzDisabled]="isPersonalOutputDisabled(rule, out)"
                ></nz-input-number>
                <input
                  *ngIf="out.type === 'text'"
                  nz-input
                  [(ngModel)]="rule.outputs[out.key]"
                  placeholder="e.g. Reach out to HR for approval."
                  [disabled]="isPersonalOutputDisabled(rule, out)"
                />
              </div>
            </div>

            <!-- Flat-slab price-by-duration row editor — only when payer=user and pricingMode=flatSlab -->
            <div *ngIf="showPersonalFlatSlabEditor(rule)" class="mt-3 pt-3 border-t border-gray-100">
              <div class="text-xs font-medium text-gray-500 mb-2">Price by session duration (minutes)</div>
              <div *ngFor="let row of personalFlatSlabRows(rule); let i = index" class="flex items-center gap-2 mb-2">
                <nz-input-number [(ngModel)]="row.minDuration" [nzMin]="0" style="width:110px" nzPlaceHolder="min (incl.)"></nz-input-number>
                <span class="text-xs text-gray-400">to</span>
                <nz-input-number [(ngModel)]="row.maxDuration" [nzMin]="0" style="width:110px" nzPlaceHolder="max (excl.)"></nz-input-number>
                <span class="text-xs text-gray-400">min →</span>
                <nz-input-number [(ngModel)]="row.amount" [nzMin]="0" style="width:120px" nzPlaceHolder="₹ amount"></nz-input-number>
                <button nz-button nzType="link" nzDanger nzSize="small" style="padding:0 4px" (click)="removePersonalFlatSlabRow(rule, i)">✕</button>
              </div>
              <button nz-button nzType="link" nzSize="small" (click)="addPersonalFlatSlabRow(rule)">+ Add duration price</button>
            </div>

            <div class="flex justify-end gap-2 mt-4 pt-3 border-t border-gray-100">
              <button nz-button nzType="default" (click)="rule.expanded = false">Cancel</button>
              <button nz-button nzType="primary" [nzLoading]="rule.saving" (click)="savePersonalRule(rule)">
                Save Personal Rule
              </button>
            </div>
          </div>
        </div>
      </div>

      <button
        class="w-full mt-2 py-2 px-4 border-dashed border rounded-lg text-sm text-gray-400 cursor-pointer hover:border-blue-400 hover:text-blue-500 hover:bg-blue-50 transition-all flex items-center justify-center gap-2"
        style="border-color:#d9d9d9; background:transparent"
        (click)="addPersonalRule()"
      >
        + Add personal rule
      </button>
    </nz-spin>
  </nz-card>

  <!-- ── Company Rules (APH-5224, read-only) ── -->
  <nz-card nzTitle="Company Rules" style="margin-top: 16px">
    <div class="text-xs text-gray-500 mb-3">
      This employee's current company's rules — read-only context. Created and edited on the
      company's own Policy Controls page, not here.
    </div>
    <nz-spin [nzSpinning]="companyRulesLoading">
      <div
        *ngIf="!companyRulesLoading && companyRulesUI.length === 0"
        class="text-center py-6 text-sm border border-dashed border-gray-200 rounded-lg text-gray-400 mb-2"
      >
        {{ userProfileResp.userCardDetails.companyId ? 'No company rules for this company yet.' : 'Company ID not available for this user yet — company rules cannot be shown.' }}
      </div>
      <div
        *ngFor="let rule of companyRulesUI"
        class="border rounded-lg mb-1.5 overflow-hidden"
        style="border-color:#e8e8e8;background:#fafafa"
      >
        <div class="flex items-center gap-2 px-4 py-2.5 select-none min-h-[46px]">
          <span
            class="text-xs font-bold px-2 py-0.5 rounded-full flex-shrink-0"
            style="background:#f0f0f0;border:1px solid #e0e0e0;color:#aaa;min-width:32px;text-align:center"
          >P{{ rule.priority }}</span>
          <span
            class="text-xs font-medium px-2 py-0.5 rounded flex-shrink-0"
            style="background:#f5f5f5;color:#555"
          >{{ rule.action }}</span>
          <span class="text-xs font-medium text-gray-700 truncate" style="max-width:140px">
            {{ rule.name }}
          </span>
          <span class="text-gray-300 flex-shrink-0">·</span>
          <span class="text-xs font-medium text-gray-500 truncate" style="max-width:120px">
            {{ personalScopeSummary(rule) }}
          </span>
          <span class="text-gray-300 flex-shrink-0">·</span>
          <span
            class="text-xs px-2 py-0.5 rounded flex-shrink-0 truncate"
            style="background:#f9fafb;border:1px solid #e8ecf4;color:#6b7280;max-width:180px"
          >{{ personalCondSummary(rule) }}</span>
          <span class="text-gray-300 flex-shrink-0">→</span>
          <span
            class="text-xs px-2 py-0.5 rounded flex-shrink-0 truncate"
            style="background:#f0fdf4;border:1px solid #bbf7d0;color:#166534;max-width:200px"
          >{{ personalThenSummary(rule) }}</span>
          <div class="flex-1"></div>
          <nz-tag [nzColor]="rule.active ? 'green' : 'default'" style="margin:0;flex-shrink:0">
            {{ rule.active ? 'Active' : 'Off' }}
          </nz-tag>
        </div>
      </div>
    </nz-spin>
  </nz-card>

  <!-- ── Global Rules (APH-5224, read-only) ── -->
  <nz-card nzTitle="Global Rules" style="margin-top: 16px">
    <div class="text-xs text-gray-500 mb-3">
      Platform-wide default rules — read-only context. Created and edited on the Global Rules
      page, not here.
    </div>
    <nz-spin [nzSpinning]="globalRulesLoading">
      <div
        *ngIf="!globalRulesLoading && globalRulesUI.length === 0"
        class="text-center py-6 text-sm border border-dashed border-gray-200 rounded-lg text-gray-400 mb-2"
      >
        No global rules configured yet.
      </div>
      <div
        *ngFor="let rule of globalRulesUI"
        class="border rounded-lg mb-1.5 overflow-hidden"
        style="border-color:#e8e8e8;background:#fafafa"
      >
        <div class="flex items-center gap-2 px-4 py-2.5 select-none min-h-[46px]">
          <span
            class="text-xs font-bold px-2 py-0.5 rounded-full flex-shrink-0"
            style="background:#f0f0f0;border:1px solid #e0e0e0;color:#aaa;min-width:32px;text-align:center"
          >P{{ rule.priority }}</span>
          <span
            class="text-xs font-medium px-2 py-0.5 rounded flex-shrink-0"
            style="background:#f5f5f5;color:#555"
          >{{ rule.action }}</span>
          <span class="text-xs font-medium text-gray-700 truncate" style="max-width:140px">
            {{ rule.name }}
          </span>
          <span class="text-gray-300 flex-shrink-0">·</span>
          <span class="text-xs font-medium text-gray-500 truncate" style="max-width:120px">
            {{ personalScopeSummary(rule) }}
          </span>
          <span class="text-gray-300 flex-shrink-0">·</span>
          <span
            class="text-xs px-2 py-0.5 rounded flex-shrink-0 truncate"
            style="background:#f9fafb;border:1px solid #e8ecf4;color:#6b7280;max-width:180px"
          >{{ personalCondSummary(rule) }}</span>
          <span class="text-gray-300 flex-shrink-0">→</span>
          <span
            class="text-xs px-2 py-0.5 rounded flex-shrink-0 truncate"
            style="background:#f0fdf4;border:1px solid #bbf7d0;color:#166534;max-width:200px"
          >{{ personalThenSummary(rule) }}</span>
          <div class="flex-1"></div>
          <nz-tag [nzColor]="rule.active ? 'green' : 'default'" style="margin:0;flex-shrink:0">
            {{ rule.active ? 'Active' : 'Off' }}
          </nz-tag>
        </div>
      </div>
    </nz-spin>
  </nz-card>

  <!-- ── DM Control table (APH-5224) ── -->
  <nz-card nzTitle="Expert DM Control" style="margin-top: 16px">
    <div class="text-xs text-gray-500 mb-3">
      One row per expert this user has an existing chat with. Turning DM off blocks new
      user/expert-initiated messages for that pair only — existing message history stays visible,
      and automated nudges keep running regardless.
    </div>
    <nz-table
      [nzData]="expertChats"
      [nzLoading]="expertChatsLoading"
      [nzShowPagination]="false"
      nzSize="small"
    >
      <thead>
        <tr>
          <th>Expert</th>
          <th>Messages</th>
          <th>Last Active</th>
          <th>DM Enabled</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of expertChats">
          <td>{{ row.therapistName }}</td>
          <td>{{ row.messageCount }}</td>
          <td>{{ formatExpertChatTime(row.lastMessageTime) }}</td>
          <td>
            <nz-spin [nzSpinning]="row.saving" nzSize="small">
              <nz-switch
                [ngModel]="isDmEnabled(row)"
                (ngModelChange)="toggleDm(row, $event)"
              ></nz-switch>
            </nz-spin>
          </td>
        </tr>
      </tbody>
    </nz-table>
    <p *ngIf="!expertChatsLoading && expertChats.length === 0" class="text-center py-4 text-sm text-gray-400">
      No expert chats yet for this user.
    </p>
  </nz-card>
</div>

<!-- ── Session policy trace drawer ── -->
<nz-drawer
  [nzClosable]="true"
  [nzVisible]="policyTraceDrawerVisible"
  nzPlacement="right"
  nzTitle="Policy Trace at Booking"
  (nzOnClose)="closePolicyTrace()"
  [nzWidth]="640"
>
  <ng-container *nzDrawerContent>
    <div *ngIf="selectedSessionTrace">
      <nz-descriptions nzBordered nzSize="small" [nzColumn]="2" class="mb-4">
        <nz-descriptions-item nzTitle="Evaluated At">{{
          selectedSessionTrace.evaluatedAt
        }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Vertical">{{
          selectedSessionTrace.verticalId
        }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Concern">{{
          selectedSessionTrace.concernId
        }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Company ID">{{
          selectedSessionTrace.companyId
        }}</nz-descriptions-item>
      </nz-descriptions>

      <nz-divider nzText="Computed Facts" nzOrientation="left"></nz-divider>
      <nz-table
        [nzData]="objectEntries(selectedSessionTrace.facts)"
        [nzShowPagination]="false"
        nzSize="small"
        class="mb-4"
      >
        <thead>
          <tr>
            <th>Fact</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let entry of objectEntries(selectedSessionTrace.facts)">
            <td>{{ entry[0] }}</td>
            <td>
              <code>{{ entry[1] | json }}</code>
            </td>
          </tr>
        </tbody>
      </nz-table>

      <nz-divider nzText="Rules Evaluated" nzOrientation="left"></nz-divider>
      <nz-list nzSize="small" class="mb-4">
        <nz-list-item
          *ngFor="let ruleId of selectedSessionTrace.applicableRuleIds"
        >
          <div class="flex items-center justify-between w-full">
            <span class="text-sm font-mono">{{ ruleId }}</span>
            <nz-tag
              [nzColor]="
                policyTraceMatchedRuleIds().has(ruleId) ? 'green' : 'default'
              "
            >
              {{
                policyTraceMatchedRuleIds().has(ruleId)
                  ? "✓ Matched"
                  : "Did not match"
              }}
            </nz-tag>
          </div>
        </nz-list-item>
      </nz-list>

      <nz-divider
        nzText="Final Outputs at Booking"
        nzOrientation="left"
      ></nz-divider>
      <nz-table
        [nzData]="objectEntries(selectedSessionTrace.outputs)"
        [nzShowPagination]="false"
        nzSize="small"
      >
        <thead>
          <tr>
            <th>Control</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let entry of objectEntries(selectedSessionTrace.outputs)">
            <td>
              <strong>{{ entry[0] }}</strong>
            </td>
            <td>
              <code>{{ entry[1] | json }}</code>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </ng-container>
</nz-drawer>
<nz-drawer
  [nzClosable]="true"
  [nzVisible]="visible"
  nzPlacement="bottom"
  [nzTitle]="title.toUpperCase()"
  (nzOnClose)="close()"
>
  <ng-container *nzDrawerContent>
    <nz-table>
      <thead>
        <tr>
          <th *ngFor="let key of selectedNestedKeys">
            {{ key }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let nestedRow of selectedRowKeys">
          <td *ngFor="let nestedKey of getKeys(nestedRow)">
            {{ nestedRow[nestedKey] }}
          </td>
        </tr>
      </tbody>
    </nz-table>
  </ng-container>
</nz-drawer>
<nz-drawer
  [nzClosable]="true"
  [nzVisible]="visibleWhatsapp"
  [nzPlacement]="placement"
  nzTitle="Send Whatsapp Message"
  (nzOnClose)="closeWhatsapp()"
  [nzSize]="'large'"
>
  <ng-container *nzDrawerContent>
    <nz-spin [nzSpinning]="loading" nzTip="Loading......">
      <div class="grid grid-cols-2 gap-2">
        <div class="flex flex-col w-full">
          <label class="form-label"> Select Whatsapp Templates : </label>
          <nz-select
            [(ngModel)]="selectedWhatsappTemplate"
            nzPlaceHolder="Select WhatsApp Templates"
            (ngModelChange)="onSearchUserChange($event)"
          >
            <nz-option
              *ngFor="let temp of whatsappTemplates"
              [nzValue]="temp.value"
              [nzLabel]="temp.data"
            ></nz-option>
          </nz-select>
        </div>
      </div>
      <nz-divider
        *ngIf="selectedGallaboxWhatsappTemplate"
        nzText="Display Actual Message Template"
      ></nz-divider>
      <div *ngIf="selectedGallaboxWhatsappTemplate" class="flex flex-col gap-2">
        @for (
          component of selectedGallaboxWhatsappTemplate.components;
          track component
        ) {
          <nz-divider
            *ngIf="selectedGallaboxWhatsappTemplate"
            [nzText]="component.type"
            nzOrientation="left"
          ></nz-divider>
          <div
            class="bg-blue-100 border border-blue-300 text-blue-800 px-4 py-3 rounded relative flex flex-col items-start gap-3"
          >
            <p class="whitespace-pre-line">{{ component.text }}</p>
            <div class="flex flex-col items-center justify-center gap-2 w-full">
              @for (btn of component.buttons; track btn) {
                <div class="w-full">
                  <div class="flex gap-4 w-full">
                    <button
                      class="text-sm px-3 py-1 bg-blue-500 text-white hover:bg-blue-600 rounded"
                    >
                      {{ btn.text }}
                    </button>
                    <!-- <input
                    class="w-6/12"
                    [(ngModel)]="btn.url"
                    placeholder="enter url"
                    nz-input
                  /> -->
                  </div>
                </div>
              }
              <!-- <button
            class="text-sm px-3 py-1 bg-blue-500 text-white hover:bg-blue-600 rounded"
            *ngFor="let btn of component.buttons"
          >
            {{ btn.text }}
          </button> -->
            </div>
            <!-- <textarea
          *ngIf="component.type === 'BODY'"
          nz-input
          rows="10"
          (ngModelChange)="onTextareaChange($event)"
          [(ngModel)]="component.text"
        ></textarea> -->
          </div>
        }
      </div>
      <nz-divider
        *ngIf="placeholders.length > 0"
        nzText="Placeholder"
      ></nz-divider>
      <nz-list nzItemLayout="horizontal">
        @for (item of placeholders; track item) {
          <nz-list-item>
            <div class="flex gap-4">
              <input
                [(ngModel)]="item.key"
                placeholder="key"
                nz-input
                [disabled]="true"
              />
              <input
                [(ngModel)]="item.value"
                placeholder="enter value"
                nz-input
              />
            </div>
          </nz-list-item>
        }
        @if (placeholders.length === 0) {
          <nz-list-empty />
        }
      </nz-list>
      <nz-divider *ngIf="urlParams.length > 0" nzText="Url params"></nz-divider>
      <nz-list nzItemLayout="horizontal" [nzLoading]="loading">
        @for (item of urlParams; track item) {
          <nz-list-item>
            <div class="flex gap-4">
              <input
                [(ngModel)]="item.key"
                placeholder="key"
                nz-input
                [disabled]="true"
              />
              <input
                [(ngModel)]="item.value"
                placeholder="enter value"
                nz-input
              />
            </div>
          </nz-list-item>
        }
        @if (urlParams.length === 0) {
          <nz-list-empty />
        }
      </nz-list>
      <div *ngIf="selectedGallaboxWhatsappTemplate" nz-row nzJustify="end">
        <div nz-col>
          <button (click)="sendWhatsappMessage()" nz-button nzType="primary">
            Send Whatsapp Message
          </button>
        </div>
      </div>
      <!-- <div class="flex flex-col gap-2" *ngIf="selectedGallaboxWhatsappTemplate">
      <div
        *ngFor="
          let placehold of selectedGallaboxWhatsappTemplate.variables;
          let i = index
        "
      >
        <div class="flex gap-2">
          <p>{{ utils.convertToTitleCase(placehold) }} :</p>
          <input
            class="w-6/12"
            [placeholder]="'Enter ' + utils.convertToTitleCase(placehold)"
            type="text"
            nz-input
          />
        </div>
      </div>
    </div> -->
    </nz-spin>
  </ng-container>
</nz-drawer>
<nz-modal
  [(nzVisible)]="isSessionBookingUnBlockModalOpen"
  [nzTitle]="'Confirm Cancellation'"
  [nzFooter]="modalFooter"
  [nzContent]="modalContent"
  (nzOnCancel)="isSessionBookingUnBlockModalOpen = false"
>
  <ng-template #modalContent>
    <p>Are you sure you want to allow the user to book sessions again?</p>
  </ng-template>
  <ng-template #modalFooter>
    <button
      nz-button
      nzType="default"
      (click)="isSessionBookingUnBlockModalOpen = false"
    >
      Cancel
    </button>
    <button nz-button nzType="primary" (click)="sessionBookingUnBlock()">
      Confirm
    </button>
  </ng-template>
</nz-modal>

<nz-modal
  [(nzVisible)]="isSessionBookingBlockModalOpen"
  [nzTitle]="'Block Session Booking'"
  [nzFooter]="blockModalFooter"
  [nzContent]="blockModalContent"
  (nzOnCancel)="isSessionBookingBlockModalOpen = false"
>
  <ng-template #blockModalContent>
    <p>Select a date until which the user cannot book sessions:</p>
    <nz-date-picker
      [(ngModel)]="blockUserTillDate"
      [nzDisabledDate]="disablePastDates"
      nzFormat="dd-MMM-yyyy"
    />
  </ng-template>

  <ng-template #blockModalFooter>
    <button
      nz-button
      nzType="default"
      (click)="isSessionBookingBlockModalOpen = false"
    >
      Cancel
    </button>
    <button
      nz-button
      nzType="primary"
      [disabled]="!blockUserTillDate"
      (click)="sessionBookingBlock()"
    >
      Block
    </button>
  </ng-template>
</nz-modal>
<nz-modal
  [(nzVisible)]="isFixMemberPassModalOpen"
  [nzTitle]="'Fix Member Pass Redemption'"
  [nzFooter]="fixMemberPassModalFooter"
  [nzContent]="fixMemberPassModalContent"
  (nzOnCancel)="isFixMemberPassModalOpen = false"
>
  <ng-template #fixMemberPassModalContent>
    <p>This will fix the member pass redemption for:</p>
    <p><strong>User:</strong> {{ userProfileResp.userCardDetails.name }}</p>
    <p><strong>Email:</strong> {{ email }}</p>
    <p>
      <strong>Partner:</strong>
      {{ getPartnerDisplay() }}
    </p>
    <br />
    <p>Are you sure you want to proceed?</p>
  </ng-template>

  <ng-template #fixMemberPassModalFooter>
    <button
      nz-button
      nzType="default"
      (click)="isFixMemberPassModalOpen = false"
    >
      Cancel
    </button>
    <button
      nz-button
      nzType="primary"
      [nzLoading]="isFixingMemberPass"
      (click)="fixMemberPassRedemption()"
    >
      Fix Member Pass
    </button>
  </ng-template>
</nz-modal>
<nz-modal
  [(nzVisible)]="visiblePh"
  [nzTitle]="'Update User Profile'"
  [nzFooter]="updateModalFooter"
  [nzContent]="updateModalContent"
  (nzOnCancel)="closeDrawer()"
  [nzOkLoading]="updateLoading"
>
  <ng-template #updateModalContent>
    <div style="margin-bottom: 12px">
      <input
        nz-input
        placeholder="Enter name"
        [(ngModel)]="displayName"
        name="userName"
      />
    </div>

    <div>
      <input
        nz-input
        placeholder="Enter phone number"
        [(ngModel)]="phoneNumber"
        name="userPhone"
      />
    </div>
  </ng-template>

  <ng-template #updateModalFooter>
    <button nz-button nzType="default" (click)="closeDrawer()">Cancel</button>
    <button
      nz-button
      nzType="primary"
      [disabled]="!displayName || !phoneNumber"
      (click)="updateUserProfile()"
    >
      Update
    </button>
  </ng-template>
</nz-modal>

<nz-modal
  [(nzVisible)]="visibleEmailModal"
  [nzTitle]="'Update User Email'"
  [nzFooter]="updateEmailModalFooter"
  [nzContent]="updateEmailModalContent"
  (nzOnCancel)="closeEmailModal()"
>
  <ng-template #updateEmailModalContent>
    <p style="margin-bottom: 12px">
      <strong>Current email:</strong>
      {{ userProfileResp.userCardDetails.email }}
    </p>
    <div>
      <input
        nz-input
        placeholder="Enter new email"
        [(ngModel)]="newEmail"
        name="newEmail"
      />
    </div>
  </ng-template>

  <ng-template #updateEmailModalFooter>
    <button nz-button nzType="default" (click)="closeEmailModal()">
      Cancel
    </button>
    <button
      nz-button
      nzType="primary"
      [disabled]="!newEmail"
      [nzLoading]="updateEmailLoading"
      (click)="updateUserEmail()"
    >
      Update
    </button>
  </ng-template>
</nz-modal>

<nz-modal
  [(nzVisible)]="visibleEmailAuditModal"
  [nzTitle]="'Email Change History'"
  [nzFooter]="null"
  [nzContent]="emailAuditModalContent"
  (nzOnCancel)="closeEmailAuditLogModal()"
>
  <ng-template #emailAuditModalContent>
    <nz-table
      #emailAuditTable
      [nzData]="emailAuditLog"
      [nzLoading]="loadingEmailAuditLog"
      [nzShowPagination]="false"
      [nzFrontPagination]="false"
    >
      <thead>
        <tr>
          <th>Changed On</th>
          <th>Changed By</th>
          <th>Old Email</th>
          <th>New Email</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let entry of emailAuditLog">
          <td>{{ formatAuditDate(entry.updatedOn) }}</td>
          <td>{{ entry.updatedByEmail }}</td>
          <td>{{ entry.oldData.email }}</td>
          <td>{{ entry.newData.email }}</td>
        </tr>
      </tbody>
    </nz-table>
    <p *ngIf="!loadingEmailAuditLog && emailAuditLog.length === 0">
      No email changes recorded for this account.
    </p>
  </ng-template>
</nz-modal>

<!-- ── Rule detail modal ── -->
<nz-modal
  [nzVisible]="ruleDetailVisible"
  [nzTitle]="selectedRule?.ruleName || 'Rule Detail'"
  [nzFooter]="null"
  [nzWidth]="720"
  (nzOnCancel)="closeRuleDetail()"
>
  <ng-container *nzModalContent>
    <div *ngIf="selectedRule" class="flex flex-col gap-4">
      <!-- Meta row -->
      <div class="flex items-center gap-2 flex-wrap">
        <span
          class="text-xs font-bold px-2 py-1 rounded"
          style="background: #f0f0f0; color: #555"
        >
          P{{ selectedRule.priority }}
        </span>
        <nz-tag
          [nzColor]="selectedRule.isGlobal ? 'blue' : 'orange'"
          style="margin: 0"
        >
          {{ selectedRule.isGlobal ? "🌐 Global" : "🏢 Partner-specific" }}
        </nz-tag>
        <nz-tag
          [nzColor]="selectedRule.matched ? 'green' : 'default'"
          style="margin: 0"
        >
          {{ selectedRule.matched ? "✓ Matched" : "Did not match" }}
        </nz-tag>
      </div>

      <!-- Scope -->
      <div>
        <p
          class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2"
        >
          FOR — Scope
        </p>
        <div class="flex flex-wrap gap-2">
          <ng-container
            *ngIf="
              resolveRuleVerticals(selectedRule.scope).length;
              else noScope
            "
          >
            <nz-tag
              *ngFor="let name of resolveRuleVerticals(selectedRule.scope)"
              nzColor="blue"
              style="margin: 0"
              >{{ name }}</nz-tag
            >
          </ng-container>
          <ng-container *ngIf="resolveRuleConcerns(selectedRule.scope).length">
            <span class="text-gray-300 self-center">·</span>
            <nz-tag
              *ngFor="let name of resolveRuleConcerns(selectedRule.scope)"
              nzColor="cyan"
              style="margin: 0"
              >{{ name }}</nz-tag
            >
          </ng-container>
          <ng-template #noScope>
            <span class="text-xs text-gray-400 italic"
              >All verticals &amp; concerns</span
            >
          </ng-template>
        </div>
      </div>

      <!-- Conditions -->
      <div *ngIf="selectedRule.conditions">
        <p
          class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2"
        >
          WHEN — Conditions
        </p>
        <div class="rounded border border-gray-200 overflow-hidden">
          <ng-container
            *ngFor="
              let cond of getConditionRows(selectedRule.conditions);
              let i = index
            "
          >
            <div
              class="flex items-center gap-3 px-3 py-2 text-sm"
              [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
            >
              <span
                *ngIf="i > 0"
                class="text-xs font-bold text-blue-500 flex-shrink-0 w-8"
              >
                {{ getConditionLogic(selectedRule.conditions) }}
              </span>
              <span
                *ngIf="i === 0"
                class="text-xs text-gray-400 flex-shrink-0 w-8"
                >IF</span
              >
              <code class="text-blue-700 font-semibold">{{ cond.fact }}</code>
              <span class="text-gray-500 font-bold">{{
                condOpLabel(cond.operator)
              }}</span>
              <code class="text-green-700">{{ cond.value }}</code>
              <span *ngIf="cond.params" class="text-xs text-gray-400"
                >(params: {{ cond.params | json }})</span
              >
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Outputs -->
      <div *ngIf="selectedRule.outputs">
        <p
          class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2"
        >
          THEN — Outputs
        </p>
        <div class="flex flex-wrap gap-2">
          <div
            *ngFor="let entry of objectEntries(selectedRule.outputs)"
            class="flex flex-col px-3 py-2 rounded border bg-green-50 border-green-200 min-w-[120px]"
          >
            <span class="text-xs text-gray-400 font-medium">{{
              entry[0]
            }}</span>
            <span class="text-sm font-bold text-green-800 mt-0.5">{{
              entry[1]
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</nz-modal>
